import { defineComponent as _defineComponent } from 'vue'
import AuthForm from '@/components/authForm/AuthForm.vue';
import { useRouter } from '@/composables';


const __default__ = {
  name: 'AuthPage',
};

export default /*#__PURE__*/_defineComponent({
  ...__default__,
  setup(__props) {

const router = useRouter();

function toMainPage() {
  router.push({ name: 'Booking' });
}

return { __sfc: true,router, toMainPage, AuthForm }
}

})